export class PrintLog {
    uuid: string;
    principal: string;
    related_uuid: string;
    received_date: string;

    before_data: string;
    after_data: string;
}
